/*
key: key of the question (question key from questionnaire DSSInformation)
defaultValue: the default value of the question
info: Extra tooltip information

display: <condition function>   decides when the question is displayed in start encounter
post: <condition function>  decides when the question needs to be posted to backend,
usually this is just the visit numbers in which the question can be asked

note - questions that need to be posted but are not displayed will be posted as NULL
note2 - display/post are now deferred to dedicated file for specific release, @see bottom file
*/

import clinicalAssessmentRelease1 from "./clinical-assessment-release1";

const clinicalAssessment = [
  // {
  //   key: 'NEW_DIAGNOSIS',
  //   defaultValue: null,
  // },
  {
    key: 'DIABETES_MELLITUS_TYPE1',
    defaultValue: null,
    info: "HbA1c ≥ 6.5 and fasting glucose ≥ 126 mg/dL or ≥ 7 mmol/L"
  },
  {
    key: 'DIABETES_MELLITUS_TYPE2',
    defaultValue: null,
    info: "HbA1c ≥ 6.5 and fasting glucose ≥ 126 mg/dL or ≥ 7 mmol/L"
  },
  {
    key: 'CHRONIC_KIDNEY_DISEASE',
    defaultValue: null,
    info: "GFR less than 60mL/min /1.73m2"
  },
  {
    key: 'HYPERTENSION',
    defaultValue: null,
    info: "Defined as office systolic blood pressure (SBP) values ≥140 mmHg and/or diastolic blood pressure (DBP) values ≥90 mmHg"
  },
  {
    // This question is no longer relevant, keeping it in v1 for legacy (v1 data comes from EDC and is only visible to admin profiles in dashboard)
    key: 'CEREBROVASCULAR_DISEASE',
    defaultValue: null,
  },
  {
    key: 'STROKE',
    defaultValue: null,
    // Note: English by specs
    label: 'Stroke'
  },
  {
    key: 'TIA',
    defaultValue: null,
    // Note: English by specs
    label: 'TIA'
  },
  {
    key: 'CAROTID_ENDARTERECTOMY',
    defaultValue: null,
    // Note: English by specs
    label: 'Carotid endarterectomy'
  },
  {
    key: 'PERIPHERAL_ARTERY_DISEASE',
    defaultValue: null,
    info: "Diagnosis with echo doppler or treatment with PTA"
  },
  {
    key: 'THROMBOEMBOLISM',
    defaultValue: null,
  },
  {
    key: 'NEW_DIAGNOSIS_HF',
    defaultValue: null,
  },
  {
    key: 'AGE',
    defaultValue: '',
  },
  {
    key: 'CHA2DS2_VASC',
    defaultValue: 0,
    info: "The CHA₂DS₂-VASc score includes female sex as a risk factor, while the CHA₂DS₂-VA score excludes it. In this tool, we calculate the CHA₂DS₂-VASc score, but we take current guideline recommendations into account when interpreting the results, meaning female sex alone does not trigger treatment advice."
  },
];

const deferDisplayToDSSRelease = deferToDSSRelease('display');
const deferPostToDSSRelease = deferToDSSRelease('post');

// Defer the choice to display/post to release file (clinical-assessment-release1, clinical-assessment-release2, etc...)
for (let i=0; i<clinicalAssessment.length; i++){
  clinicalAssessment[i].display = deferDisplayToDSSRelease
  clinicalAssessment[i].post = deferPostToDSSRelease
}

/**
 *
 * @param key
 * @param config
 * @returns {{defaultValue: null, key: string, info: string}}
 */
export const getClinicalAssessmentQuestion = function (key, config = null){
  if (!config){
    config = clinicalAssessment;
  }

  for (let i=0; i<config.length;i++)
    if (config[i].key === key)
      return config[i]
}

/**
 *
 * @param deferField
 * @returns {(function(*): (*|boolean))|*}
 */
function deferToDSSRelease(deferField) {
  return function (runObject) {
    const
        {rootGetters, visit} = runObject,
        question = runObject.config.key,
        encounter = rootGetters['patientSummary/getEncounter'](visit)
    ;

    // Get release that was run for this visit, if encounter didn't exist yet or release was not run yet, get last release
    const targetRelease = encounter && encounter.DSSRelease ? encounter.DSSRelease : rootGetters.getServerInfo("dssRelease");

    let questions;

    switch (targetRelease) {
      case 'release1':
        questions = clinicalAssessmentRelease1;
        break;
      case 'release2':
        questions = clinicalAssessmentRelease1;
        break;
      case 'release3':
        questions = clinicalAssessmentRelease1;
        break;
      case 'release4':
        questions = clinicalAssessmentRelease1;
        break;
      default:
        throw new Error("Unconfigured questions for release " + targetRelease);
    }

    const questionConfig = getClinicalAssessmentQuestion(question, questions)

    if (questionConfig?.[deferField]) {
      return questionConfig[deferField](runObject)
    }

    return false
  }
}

export default clinicalAssessment;